import { Component, OnInit } from '@angular/core';
import { DialogService, DialogData } from '../../../services/dialog.service';
import { OrderService } from '@app/services/order.service';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'app-confirmation-dialog',
    templateUrl: './confirmation-dialog.component.html',
    styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit {
    activeDialog: DialogData | null = null;

    constructor(private dialogService: DialogService, private orderService: OrderService, private toastr: ToastrService,) { this.driverList = []; }

    ngOnInit(): void {
        this.dialogService.dialogState$.subscribe(data => {
            this.activeDialog = data;
            if (this.activeDialog?.confirmText === 'Assign') {
                this.driverList = [];
                 this.selectedDriverId = '';
                this.getDriversForReassign();
            }
        });
    }

    onConfirm(): void {
        if (this.activeDialog) {
            this.dialogService.close(true, this.activeDialog);
        }
    }
    selectedDriverId: any = null;
AssignConfirm(): void {
  if (!this.selectedDriverId) {
    this.toastr.error('Please select a driver');
    return;
  }

  if (this.activeDialog) {
    this.dialogService.close(true, this.activeDialog, {
      driverId: this.selectedDriverId   // 👈 yahin bhej rahe ho
    });
  }
}


    onCancel(): void {
        if (this.activeDialog) {
            this.dialogService.close(false, this.activeDialog);
        }
    }
    driverList: any[] = [];
    getDriversForReassign(): void {
        this.orderService.getActiveDriversForAssign().subscribe({
            next: (res) => {
                if (res.result.special_group_info) {
                    this.driverList.push({
                        value: res.result.special_group_info.id,
                        label: res.result.special_group_info.name,
                    });
                }
                res.result.results.forEach((data: any) => {
                    this.driverList.push({
                        value: data?.id,
                        label: `${data?.activity_status == 'True' ? '🟢 ' : ''}${data?.first_name} ${data?.last_name} ${data?.groups?.[0]?.id == 3 ? ' (HD)' : ''} ${data?.is_online ? '' : '(Offline)'}`,
                    });
                });
            },
            error: (err) => {
                console.error('Error while fetching drivers', err);
            }
        });
    }
}
